import { all } from 'redux-saga/effects';
import changePassSaga from 'components/layouts/saga/changePass';
import leftMenuSaga from 'components/layouts/saga/leftMenu';
import headerSaga from './header';

export default function* layoutSaga() {
  yield all([changePassSaga(), leftMenuSaga(), headerSaga()]);
}
